
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faLinkedinIn, faXTwitter, faInstagram, faGithub } from '@fortawesome/free-brands-svg-icons';
// import { faUser } from '@fortawesome/free-solid-svg-icons';

// export default function Aboutme({ REF }) {
//     return (
//         <div ref={REF} className="min-h-screen flex justify-center items-center">
//             <div className="mx-4 mt-40 md:mt-0 flex flex-col md:flex-row justify-between items-center gap-20">
//                 <div className="max-w-96 flex flex-col gap-10">
//                     <div className="flex flex-col">
//                         <h1 className="text-4xl font-black font-Viga tracking-tight text-slate-50">ELKAMAL Mohammed</h1>
//                         <h2 className="ml-2 mt-2 text-lg font-bold font-Viga tracking-tight text-slate-100">Software Developer</h2>
//                         <p className="ml-2 mt-8 font-Open text-lg tracking-tight tracking-2 text-slate-100">As a dedicated full-stack developer and software engineer, I specialize in creating intuitive and engaging user experiences. I am passionate about staying current with industry trends and best practices. My experience as a 1337 student has strengthened my ability to engage with emerging technologies, allowing me to continuously improve my skills. I strive to deliver high-quality, user-centered solutions that meet evolving needs.</p>
//                     </div>
//                     <div className="w-full flex justify-between items-center">
//                         <div className="flex gap-4 text-xl text-white">
//                             <a target="_blank" rel="noreferrer" href="https://x.com/Muhamma84986027" className="hover:border hover:border-slate-500 transition duration-500 ease-in-out w-10 h-10 rounded-xl bg-black hover:bg-transparent flex justify-center items-center"><FontAwesomeIcon icon={faXTwitter} /></a>
//                             <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/mohammed-elkamal-b07797199" className="hover:border hover:border-slate-500 transition duration-500 ease-in-out w-10 h-10 hover:bg-transparent bg-blue-700 rounded-xl flex justify-center items-center p-2 "><FontAwesomeIcon icon={faLinkedinIn} /></a>
//                             <a target="_blank" rel="noreferrer" href="https://www.instagram.com/mo_elkamel/" className="hover:border hover:border-slate-500 transition duration-500 ease-in-out w-10 h-10 delay-1000 hover:from-transparent hover:to-from-transparent bg-gradient-to-r from-[#f9ce34] via-[#ee2a7b] to-[#6228d7] rounded-xl flex justify-center items-center p-2 "><FontAwesomeIcon icon={faInstagram} /></a>
//                             <a target="_blank" rel="noreferrer" href="https://github.com/moelkama/" className="hover:border hover:border-slate-500 transition duration-500 ease-in-out w-10 h-10 hover:text-white hover:bg-transparent text-black bg-white rounded-xl flex justify-center items-center p-2 "><FontAwesomeIcon icon={faGithub} /></a>
//                         </div>
//                         <a href="/ELKAMAL_MOHAMMED.pdf" target="_blank" rel="noreferrer" className="transition duration-500 ease-in-out text-center text-xl min-h-10 px-4 bg-black hover:text-black text-slate-300 hover:bg-white flex gap-2 borde rounded-xl justify-center items-center">
//                             <h1 className=" font-black font-sans">CV</h1>
//                             <FontAwesomeIcon className="" icon={faUser} />
//                         </a>
//                     </div>
//                 </div>
//                 <div className="backdrop-sepia bg-white/5 backdrop-blur-lg min-h-[468px] max-w-[440px] rounded-3xl flex flex-col justify-evenly p-6 text-lg font-bold tracking-tight text-slate-300">
//                     <div className="">
//                         <p className="first-letter:text-2xl first-letter:text-wh mt-2">When I was young, my curiosity always drove me to understand how electronic devices work, and that same curiosity now motivates me to delve deeper into their development, aiming to make them more seamless</p>
//                         <p className="first-letter:text-2xl first-letter:text-wh mt-2">My goal now is to enhance my skills as a Software engineers and continue my studies in technologies, particularly in the field of quantum computers, since I am also a physics student.</p>
//                         <p className="first-letter:text-2xl first-letter:text-wh mt-2">I love traveling, exploring, playing football, and watching movies and TV series.</p>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

import { motion } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn, faXTwitter, faInstagram, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faUser } from '@fortawesome/free-solid-svg-icons';

const socials = [
  {
    icon: faXTwitter,
    href: "https://x.com/Muhamma84986027",
    className: "bg-black hover:bg-transparent hover:border hover:border-slate-500"
  },
  {
    icon: faLinkedinIn,
    href: "https://www.linkedin.com/in/mohammed-elkamal-b07797199",
    className: "bg-blue-700 hover:bg-transparent hover:border hover:border-slate-500"
  },
  {
    icon: faInstagram,
    href: "https://www.instagram.com/mo_elkamel/",
    className:
      "bg-gradient-to-r from-[#f9ce34] via-[#ee2a7b] to-[#6228d7] hover:border hover:border-slate-500"
  },
  {
    icon: faGithub,
    href: "https://github.com/moelkama/",
    className:
      "bg-white text-black hover:text-white hover:bg-transparent hover:border hover:border-slate-500"
  }
];


export default function Aboutme({ REF }) {

    const container = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const fadeUp = {
        hidden: { opacity: 0, y: 40 },
        show: { 
            opacity: 1, 
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    const fadeRight = {
        hidden: { opacity: 0, x: 60 },
        show: { 
            opacity: 1, 
            x: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    return (
        <div ref={REF} className="min-h-screen flex justify-center items-center">
            <motion.div
                variants={container}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                className="mx-4 mt-40 md:mt-0 flex flex-col md:flex-row justify-between items-center gap-20"
            >
                {/* Left Section */}
                <motion.div variants={fadeUp} className="max-w-96 flex flex-col gap-10">
                    
                    <div className="flex flex-col">
                        <h1 className="text-4xl font-bold font-poppins tracking-tight text-slate-50">Elkamal Mohammed</h1>
                        <h2 className="mt-2 text-lg font-bold font-Viga tracking-tight text-slate-300">Software Developer</h2>
                        <p className="ml-2 mt-8 font-poppins text-justify text-lg tracking-tight tracking-2 text-slate-100">As a dedicated software engineer, I specialize in creating intuitive and engaging user experiences. I am passionate about staying current with industry trends and best practices. My experience as a 1337 student has strengthened my ability to engage with emerging technologies, allowing me to continuously improve my skills. I strive to deliver high-quality, user-centered solutions that meet evolving needs.</p>
                    </div>

                    {/* Social Icons */}
                    <motion.div 
                        variants={container}
                        className="w-full flex justify-between items-center"
                    >
                        <div className="flex gap-4 text-xl text-white">
                            {socials.map((s, i) => (
                                <motion.a
                                    key={i}
                                    variants={fadeUp}
                                    whileHover={{ scale: 1.2 }}
                                    whileTap={{ scale: 0.9 }}
                                    className={`cursor-pointer ease-in-out w-10 h-10 rounded-xl flex justify-center items-center ${s.className}`}
                                >
                                    <FontAwesomeIcon icon={s.icon} />
                                </motion.a>
                            ))}
                        </div>

                        <motion.a
                            variants={fadeUp}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            href="/ELKAMAL_MOHAMMED.pdf"
                            target="_blank"
                            rel="noreferrer"
                            className="text-xl min-h-10 px-4 bg-black text-slate-300 hover:bg-white hover:text-black flex gap-2 rounded-xl justify-center items-center"
                        >
                            <h1 className="font-bold font-sans">CV</h1>
                            <FontAwesomeIcon icon={faUser} />
                        </motion.a>
                    </motion.div>
                </motion.div>

                {/* Right Card */}
                <motion.div 
                    variants={fadeRight}
                    className="backdrop-sepia bg-white/5 backdrop-blur-lg min-h-[468px] max-w-[440px] rounded-3xl flex flex-col justify-evenly p-6 text-lg font-poppins tracking-tight text-slate-300"
                >
                    <p className="first-letter:text-2xl first-letter:text-wh mt-2">When I was young, my curiosity always drove me to understand how electronic devices work, and that same curiosity now motivates me to delve deeper into their development, aiming to make them more seamless</p>
                    <p className="first-letter:text-2xl first-letter:text-wh mt-2">My goal now is to enhance my skills as a Software engineers and continue my studies in technologies, particularly in the field of quantum computers, since I am also a physics student.</p>
                    <p className="first-letter:text-2xl first-letter:text-wh mt-2">I love traveling, exploring, playing football, and watching movies and TV series.</p>
                </motion.div>

            </motion.div>
        </div>
    );
}
